var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ForecastVisualParams_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { VisualParams } from './visualParams';
import { VisualType } from '@symon-ai/wisepipe-base-computation';
import { forecastVisualParamsSchemaValidation } from '../validations.generated';
export const forecastVisualParamsSchema = {
    $id: 'urn:wisepipe-common-computation:ForecastVisualParams',
    type: 'object',
    properties: {
        xAxis: { type: 'string', minLength: 1 },
        analyzeBy: { type: 'array', items: { type: 'string', minLength: 1 }, uniqueItems: true },
        isForecast: { type: 'string', minLength: 1 },
        historicalValue: { type: 'string', minLength: 1 },
        forecastedValue: { type: 'string', minLength: 1 },
        forecastLower: { type: 'string', minLength: 1 },
        forecastUpper: { type: 'string', minLength: 1 }
    },
    required: ['xAxis', 'isForecast', 'historicalValue', 'forecastedValue', 'forecastLower', 'forecastUpper']
};
let ForecastVisualParams = ForecastVisualParams_1 = class ForecastVisualParams extends VisualParams {
    constructor(args) {
        super({
            ...args,
            type: VisualType.Forecast
        });
        this.xAxis = args.xAxis;
        this.analyzeBy = args.analyzeBy;
        this.isForecast = args.isForecast;
        this.historicalValue = args.historicalValue;
        this.forecastedValue = args.forecastedValue;
        this.forecastLower = args.forecastLower;
        this.forecastUpper = args.forecastUpper;
        JSON.validate(this, ForecastVisualParams_1);
    }
    static get xAxisAlias() {
        return 'xAxis';
    }
    static getAnalyzeByAlias(i) {
        return `analyze_by_${i}`;
    }
    static get isForecastAlias() {
        return 'isForecast';
    }
    static get historicalValueAlias() {
        return 'historicalValue';
    }
    static get forecastedValueAlias() {
        return 'forecastedValue';
    }
    static get forecastLowerAlias() {
        return 'forecastLower';
    }
    static get forecastUpperAlias() {
        return 'forecastUpper';
    }
    getFields() {
        const analyzeByColumns = this.analyzeBy ?? [];
        return [
            { source: this.xAxis, alias: ForecastVisualParams_1.xAxisAlias },
            ...analyzeByColumns.map((s, i) => {
                return {
                    source: s,
                    alias: ForecastVisualParams_1.getAnalyzeByAlias(i)
                };
            }),
            { source: this.isForecast, alias: ForecastVisualParams_1.isForecastAlias },
            { source: this.historicalValue, alias: ForecastVisualParams_1.historicalValueAlias },
            { source: this.forecastedValue, alias: ForecastVisualParams_1.forecastedValueAlias },
            { source: this.forecastLower, alias: ForecastVisualParams_1.forecastLowerAlias },
            { source: this.forecastUpper, alias: ForecastVisualParams_1.forecastUpperAlias }
        ];
    }
    setFinalQuery(query, type, tableName) {
        return query;
    }
};
ForecastVisualParams = ForecastVisualParams_1 = __decorate([
    JsonSchemaV2(forecastVisualParamsSchema, forecastVisualParamsSchemaValidation),
    JsonDiscriminatorValue(VisualType.Forecast)
], ForecastVisualParams);
export { ForecastVisualParams };
//# sourceMappingURL=forecastVisualParams.js.map